import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { BorderBottom } from "@mui/icons-material";

import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import { getUserLocation } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { formatIndianAmount, getAvgPricePerSqft } from "../Services/Helper";
import { getDisplayPrice } from "../Services/Helper";
import SelectDialog from "../Common/Dialog/Select";
import { toast } from "react-toastify";

const images = [
  "https://picsum.photos/id/1011/800/500",
  "https://picsum.photos/id/1012/800/500",
  "https://picsum.photos/id/1013/800/500",
  "https://picsum.photos/id/1015/800/500",
  "https://picsum.photos/id/1016/800/500",
];

function PropertyDetails() {
  const {
    logindata,

    userData,
  } = useContext(ApiContext);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const listingID = params.get("id");
  const TabID = location?.state?.TabID;

  const [open, setOpen] = useState(false);
  const [listingDetails, setlistingDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showStatusPopup, setshowStatusPopup] = useState(false);

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // const totalImages = images.length;

  const mainSettings = {
    asNavFor: nav2,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    swipeToSlide: true,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  const thumbSettings = {
    asNavFor: nav1,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    swipeToSlide: true,
    infinite: true,
    arrows: false,
  };

  useEffect(() => {
    getListingDetails(listingID);
  }, []);

  const getListingDetails = (id) => {
    getRecords(TabID, 1, `{ListingID: { $in: [${id}] }}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setlistingDetails(data?.response?.records[0] || null);

          setLoading(false);
        } else {
          setLoading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const csvFields = [
    listingDetails?.Images,
    listingDetails?.KitchenImage,
    listingDetails?.BathroomImage,
    listingDetails?.BalconyImage,
    listingDetails?.LivingroomImage,
    listingDetails?.LocalityImage,
    listingDetails?.Facing,
    listingDetails?.FloorPlanImage,
    listingDetails?.DiningAreaImage,
    listingDetails?.Others,
    listingDetails?.ElevationImage,
    listingDetails?.BedroomImage,
  ];

  const sliderImages = csvFields
    .filter((v) => typeof v === "string" && v.trim())
    .flatMap((v) => v.split(",").map((i) => i.trim()))
    .filter(Boolean); // removes empty strings

  const totalImages = sliderImages.length;

  const highlights =
    typeof listingDetails?.KeyHighlights === "string" &&
    listingDetails.KeyHighlights.trim()
      ? listingDetails.KeyHighlights.split(",")
          .map((h) => h.trim())
          .filter(Boolean)
      : [];

  const changeStatus = (flag) => {
    const postData = [
      {
        ListingID: listingID,

        Status: flag === 0 ? "In Review" : flag === 1 ? "Approved" : "Declined",
        StatusID: flag === 0 ? 1 : flag === 1 ? 2 : 3,
      },
    ];

    PostRecords(TabID, 1, postData, (data) => {
      if (data != null && data?.response?.hasErrors === false) {
        toast.success(`Status Updated Successfully`);
        getListingDetails(listingID);
      } else {
        toast.error(`${data?.errors}`);
      }
    });
  };

  return (
    <>
      <Header />
      <div className="content-wrapper bg-seashell">
        <section className="property-details-wrap ptb-50">
          <div className="container">
            <div className="row gx-5">
              <div className="col-xl-8">
                <div className="property-details">
                  <div className="card mb-30">
                    <Box position="relative">
                      <Box
                        sx={{
                          position: "absolute",
                          top: 12,
                          right: 12,
                          zIndex: 2,
                          background: "rgba(0,0,0,0.6)",
                          color: "#fff",
                          padding: "4px 10px",
                          borderRadius: "12px",
                          fontSize: 14,
                        }}
                      >
                        {activeIndex + 1} / {totalImages}
                      </Box>

                      <Slider {...sliderSettings}>
                        {sliderImages?.length > 0 && sliderImages != null
                          ? sliderImages?.map((img, index) => (
                              <div key={index}>
                                <img
                                  src={img.trim()}
                                  alt={`slide-${index}`}
                                  style={{
                                    width: "100%",
                                    height: "280px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            ))
                          : images?.map((img, index) => (
                              <div key={index}>
                                <img
                                  src={img}
                                  alt={`slide-${index}`}
                                  style={{
                                    width: "100%",
                                    height: "280px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            ))}
                      </Slider>

                      {/* View All Button */}
                      <div style={{ textAlign: "right", marginTop: -50 }}>
                        <Button
                          variant="outlined"
                          onClick={() => setOpen(true)}
                          className="vallimages"
                        >
                          View All Images
                        </Button>
                      </div>
                    </Box>
                  </div>
                  <div className="card pd-20 mb-30">
                    <div class="property-title mb-0">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h2>{listingDetails?.Title}</h2>{" "}
                        <span className="prce">
                          {getDisplayPrice(listingDetails)}
                        </span>
                      </div>

                      <ul
                        class="property-metainfo list-style"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <li>
                          <i class="flaticon-location"></i>
                          {listingDetails?.Locality}
                        </li>
                        <li>
                          {listingDetails?.BuiltUpArea}{" "}
                          {listingDetails?.UOMName}
                        </li>
                      </ul>
                      <div
                        className="headss"
                        style={{
                          marginLeft: 0,
                          borderBottom: "1px solid #f2f2f2",
                          marginBottom: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <ul
                          className="property-metainfo list-style"
                          style={{
                            whiteSpace: "nowrap",
                            marginTop: 20,
                            marginBottom: 20,
                          }}
                        >
                          {Array.isArray(listingDetails?.UnitFurnishingtitle) &&
                            listingDetails.UnitFurnishingtitle.length > 0 &&
                            listingDetails.UnitFurnishingtitle.map(
                              (title, index) => (
                                <li key={index}>
                                  <img
                                    src={title?.UnitFurnishingIcon}
                                    alt="Furniture"
                                    style={{ height: 25, width: 25 }}
                                    // className="furnishing-icon"
                                  />
                                  {listingDetails?.Quantity
                                    ? `${listingDetails.Quantity} `
                                    : ""}
                                  {title?.UnitFurnishingtitle}
                                </li>
                              )
                            )}
                        </ul>

                        {/* <div className="chipps" style={{ marginLeft: 20 }}>
                          <span className="property-condo">
                            {listingDetails?.ChooseProperty}
                          </span>
                          <span className="property-status">
                            {listingDetails?.FurnishType}
                          </span>
                        </div> */}
                      </div>

                      <div className="filterownerchip">
                        <div className="agent d-flex">
                          <div
                            className="chipsn chip"
                            style={{ padding: "7px 17px" }}
                          >
                            {" "}
                            <i className="ri-shield-check-line"></i>Verified
                            Agent
                          </div>
                          <div className="chipps" style={{ marginLeft: 20 }}>
                            <span className="property-condo">
                              {listingDetails?.ChooseProperty}
                            </span>
                            <span className="property-status">
                              {listingDetails?.FurnishType}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card pd-20 mb-30">
                    <h5>Description</h5>
                    <div class="property-desc">
                      <p className="mb-20">{listingDetails?.Description}</p>

                      <h6>Key Highlights</h6>

                      <ul className="highlist">
                        {highlights?.length > 0 &&
                          highlights?.map((data, i) => {
                            return <li key={i}>{data}</li>;
                          })}
                      </ul>
                    </div>
                  </div>

                  <div className="card pd-20 mb-30 amenities">
                    <h5>Amenities</h5>
                    <div class="property-desc">
                      <div className="row d-flex df">
                        {Array.isArray(listingDetails?.PropertyAmenities) &&
                          listingDetails.PropertyAmenities.length > 0 &&
                          listingDetails.PropertyAmenities.map(
                            (amenity, index) => (
                              <div className="property-card style3" key={index}>
                                <div className="property-info">
                                  <div className="icons">
                                    <img
                                      src={amenity?.PropertyAmenitiesIcon}
                                      alt="Furniture"
                                      style={{ height: 30, width: 30 }}
                                      // className="furnishing-icon"
                                    />
                                  </div>
                                  <p>{amenity?.PropertyAmenities}</p>
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="card pd-20 mb-30 amenities">
                    <h5>Property Details</h5>
                    <div class="property-desc mb-0">
                      <ul className="htlist">
                        <li className="d-flexx">
                          <span>Property ID</span>
                          <span>{listingDetails?.ListingID}</span>
                        </li>
                        <li className="d-flexx">
                          <span>Property Age</span>
                          <span>{listingDetails?.PropertyAge}</span>
                        </li>
                        <li className="d-flexx">
                          <span>Floor</span>
                          <span>
                            {listingDetails?.FloorNo} Floor of{" "}
                            {listingDetails?.TotalFloors}
                          </span>
                        </li>
                        <li className="d-flexx">
                          <span>Possession</span>
                          <span>{listingDetails?.ConstructionStatus}</span>
                        </li>
                        <li className="d-flexx">
                          <span>Facing</span>
                          <span>{listingDetails?.Facing}</span>
                        </li>
                        <li className="d-flexx">
                          <span>Property Status</span>
                          <span>{listingDetails?.Status}</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="card pd-20 mb-30">
                    <h5>Location</h5>
                    <div class="property-desc mb-0">
                      <ul
                        class="property-features list-style lst mb-0"
                        style={{ marginBottom: 0 }}
                      >
                        <li className="reraa">
                          <div className="d-flex">
                            <div className="grey ico">
                              <i class="ri-map-pin-line text-green-600 text-xl mt-1"></i>
                            </div>
                            <div>
                              <small className="d-block">
                                {listingDetails?.City}
                              </small>
                              <small className="d-block">
                                {listingDetails?.Locality}
                              </small>
                              <a
                                href={`https://www.google.com/maps?q=${listingDetails?.Coordinates[0]},${listingDetails?.Coordinates[1]}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i class="ri-map-2-line"></i> View on Map
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="property-details">
                  <div className="card pd-20 mb-30">
                    <div class="property-title mb-0">
                      <h5>Contact Agent</h5>

                      <div className="d-flex">
                        <div className="dev">
                          <div className="developer">
                            <img
                              src="assets/img/clients/client-1.jpg"
                              alt="Image"
                            />

                            <i class="ri-shield-check-fill text-white icnss"></i>
                          </div>
                        </div>
                        <div>
                          <span>
                            <b>{listingDetails?.SellerName}</b>
                          </span>
                          <div className="agent d-flex">
                            <div className="agent">
                              {" "}
                              <i className="ri-shield-check-line"></i>Verified
                              Agent
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="header-btn d-block dev">
                        <button type="button" className="btn style1">
                          <i class="ri-phone-line"></i> Call Now
                        </button>

                        <button type="button" className="btn style3 loginbtn">
                          <i class="ri-mail-line"></i> Email
                        </button>

                        <button type="button" className="btn style3 loginbtn">
                          {" "}
                          Get Callback{" "}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="card pd-20 mb-30">
                    <h5>Quick Actions</h5>
                    <div class="property-desc">
                      <div className="header-btn d-block dev savepr">
                        <button type="button" className="btn style3 loginbtn">
                          <span class="text-lg">🖤</span> Save Property
                        </button>

                        <button type="button" className="btn style3 loginbtn">
                          <i class="ri-share-line"></i> Share Property{" "}
                        </button>
                        {userData?.UserID == listingDetails?.SellerID && (
                          <button type="button" className="btn style3 loginbtn">
                            <i class="ri-edit-line"></i> Edit Property{" "}
                          </button>
                        )}

                        {userData?.ProfileID === 4 && (
                          <button
                            onClick={() => setshowStatusPopup(true)}
                            type="button"
                            className="btn style3 loginbtn"
                          >
                            <i class="ri-status-line"></i> Change Status{" "}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <SelectDialog
        open={showStatusPopup}
        onClose={() => setshowStatusPopup(false)}
        onSubmit={(data) => {
          changeStatus(data);
          setshowStatusPopup(false);
        }}
      />

      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}

      {/* Gallery Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <IconButton
          onClick={() => setOpen(false)}
          style={{ position: "absolute", right: 8, top: -3, zIndex: 9999 }}
        >
          x
        </IconButton>

        <DialogContent style={{ padding: 0, overflowY: "clip" }}>
          <Box position="relative">
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 2,
                background: "rgba(0,0,0,0.6)",
                color: "#fff",
                padding: "4px 10px",
                borderRadius: "12px",
                fontSize: 14,
              }}
            >
              {activeIndex + 1} / {totalImages}
            </Box>

            {/* Main Slider */}
            <Slider {...mainSettings} ref={(s) => setNav1(s)}>
              {sliderImages.map((img, index) => (
                <Box key={index}>
                  <img
                    src={img}
                    alt=""
                    style={{
                      width: "100%",
                      height: 400,
                      objectFit: "cover",
                      borderRadius: 0,
                    }}
                  />
                </Box>
              ))}
            </Slider>

            {/* Thumbnail Slider */}
            <Box mt={2}>
              <Slider {...thumbSettings} ref={(s) => setNav2(s)}>
                {sliderImages.map((img, index) => (
                  <Box key={index} px={0.5}>
                    <img
                      src={img}
                      alt=""
                      style={{
                        width: "100%",
                        height: 80,
                        objectFit: "cover",
                        borderRadius: 0,
                        cursor: "pointer",
                        border:
                          activeIndex === index
                            ? "2px solid #1976d2"
                            : "2px solid transparent",
                      }}
                    />
                  </Box>
                ))}
              </Slider>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Footer />
    </>
  );
}

export default PropertyDetails;
